import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import actions from './actions'
import getters from './getters'
import modules from './modules'

Vue.use(Vuex)

let store = new Vuex.Store({
  actions,
  getters,
  modules
})

try {
  store = new Vuex.Store({
    actions,
    getters,
    modules,
    plugins: [
      createPersistedState({
        key: 'ccb',
        paths: ['user', 'tool']
      })
    ]
  })
} catch (e) {
  console.log('e', e)
}

if (!__BUILD__) {
  if (import.meta.hot) {
    import.meta.hot.accept(['./actions', './getters', './modules'], () => {
      store.hotUpdate({
        actions,
        getters,
        modules
      })
    })
  }
}

export default store
